<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dmDsG2/tc-custom/9780811762120.jpg?1724846793109" alt="This image is the cover for the book Goodbye, Transylvania, Stackpole Military History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Goodbye, Transylvania, Stackpole Military History Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Romanian soldier details serving for Germany on the Eastern Front during World War II in this memoir, featuring firsthand accounts of combat.</b></p> German by ancestry, born and raised in the ethnic welter of post-World War I Romania, Sigmund Heinz Landau left his home to volunteer for the Third Reich during World War II. Serving on the Eastern Front, he saw nearly six years of continuous fighting with a <i>Luftwaffe</i> Flak unit and eventually in the <i>Waffen-SS</i>, from sentry duty to desperate attacks against Soviet T-34s, from the siege of Budapest to the final campaign for Berlin in 1945. Landau’s memoir, written from a unique perspective, offers rare insight into what motivated soldiers to fight—and die—for Nazi Germany. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sigmund Heinz Landau
      </h2>
      
      <p class="authorDescription body article">Sigmund Heinz Landau was born in Transylvania in 1920.  After the war Landau moved to England, where he died in 1998.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Stackpole Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?74ff914d